import {defaultRequest, formatter, nonBuRequest, ResponseStatus} from '@/utils/request';
import qs from 'qs';
import {BU} from '@/services/basic/bu';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export namespace NSToken {

  function save(token: API.TokenBody) {
    const refreshTime = new Date().getTime() + token.expires_in * 1000;
    localStorage.setItem('refreshTime', refreshTime.toString());
    localStorage.setItem('accessToken', token.access_token);
    localStorage.setItem('refreshToken', token.refresh_token);
    localStorage.setItem('refreshing', "false");
    localStorage.setItem('refreshingResult', "true");
  }

  export function clearToken() {
    localStorage.removeItem('refreshTime');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }

  export function accessToken() {
    return localStorage.getItem('accessToken');
  }

  export function isRefreshing() {
    return localStorage.getItem('refreshing') === "true";
  }

  export function refreshingSuccess() {
    return localStorage.getItem('refreshingResult') === "true";
  }

  export function validate() {
    const lastTokenRefresh = Number(localStorage.getItem("refreshTime"));
    const current = new Date().getTime();
    let res = true;
    if (Number.isNaN(lastTokenRefresh)) {
      res = false;
    } else if (current > lastTokenRefresh) {
      res = false;
    }
    if (!accessToken()) {
      res = false;
    }
    return res;
  }
// 初始化并获取访客标识符
  async function getDeviceFingerprint() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const deviceId = result.visitorId;
    console.log('获取唯一标识:', deviceId, result);
    return deviceId;
  }
  export async function fetch(body: any) {
    const fingerPrint = await getDeviceFingerprint();
    return defaultRequest('/basicapi/oauth/token', {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Finger-Print': fingerPrint
      },
      body: qs.stringify(body),
      method: 'POST'
    }).then((res) => {
      let tokenResult: API.TokenResult = {
        status: ResponseStatus.UNKNOWN,
        message: res.message
      };

      if (res.code == 200) {
        tokenResult.data = {
          access_token: res.data.access_token,
          expires_in: res.data.expires_in,
          refresh_token: res.data.refresh_token
        }
        tokenResult.status = ResponseStatus.SUCCESS;
        save(tokenResult.data)
      } else {
        clearToken();
      }
      return tokenResult;
    }).catch((error) => {
      const response: API.TokenResult = {
        status: ResponseStatus.UNKNOWN,
        message: error
      }
      return response;
    });
  }

  export async function get(body: API.LoginParams) {
    return fetch({
      ...body,
      grant_type: 'password',
      client_id: 'apiclient',
      client_secret: 'apisecret',
    });
  }

  /**异步延时函数 await delay(1000) */
  const delay = (ms: number) => new Promise((resolve, reject) => setTimeout(resolve, ms));

  export async function refresh() {
    if (isRefreshing()) {
      // 循环等待 查询刷新token是否完成, 每次等待10ms
      let timelong = 0;
      while (isRefreshing() && timelong < 2000) {
        timelong += 100;
        await delay(100);
      }

      let tokenResult: API.TokenResult = {
        status: (!isRefreshing() && refreshingSuccess()) ? ResponseStatus.SUCCESS : ResponseStatus.UNKNOWN
      };
      // 返回 一个空Promise对象
      return Promise.resolve(tokenResult);
    } else {
      localStorage.setItem('refreshing', "true");
      localStorage.setItem('refreshingResult', "false");
      return fetch({
        grant_type: 'refresh_token',
        client_id: 'apiclient',
        client_secret: 'apisecret',
        refresh_token: localStorage.getItem('refreshToken'),
      }).then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          localStorage.setItem('refreshingResult', "true");
        }
        localStorage.setItem('refreshing', "false");
        return res;
      });
    }

  }

  // 根据token获取用户信息，不需要检验token和bu一致
  export async function getUserinfo() {
    return nonBuRequest('/basicapi/oauth/userinfo', formatter({method: "GET"})).then((res) => {
      const user: API.SysUser = {
        userId: res.userId,
        roleId: res.roleId,
        loginName: res.loginName,
        lcId: res.lcId,
        deptId: res.deptId,
        isManager: res.isManager,
        buId: res.buId
      };
      return {
        status: ResponseStatus.SUCCESS,
        data: user
      }
    });
  }

  // 标准模式用户名密码登录
  export async function login1(body: API.LoginParams, sso?: number) {
    let tokenResult: API.TokenResult;
    if (sso === 2) {
      tokenResult = await fetch({
        ...body,
        customAuthType: "2",
        grant_type: 'custom',
        client_id: 'apiclient',
        client_secret: 'apisecret',
      });
    } else {
      tokenResult = await get({...body});
    }
    let loginResult: API.LoginResult;
    if (tokenResult.status === ResponseStatus.SUCCESS) {
      const res = await getUserinfo();
      // 获取用户之后设置当前页面的BU信息，后续所有请求需要在header中绑定bu
      if (res && res.data) {
        NSToken.setBu(res.data.buId);
        const bu = await BU.get(res.data.buId)
        NSToken.setBuName(bu.data.buName)
      } else {
        NSToken.clearBu();
      }
      loginResult = {
        status: ResponseStatus.SUCCESS,
        data: res.data
      }
    } else {
      loginResult = {
        status: ResponseStatus.UNKNOWN,
        message: '用户名或密码不正确'
      }
    }
    return loginResult;
  }

  // 切换职务或者bu，重新获取token
  export function switchPosition(positionId: number) {
    return fetch({
      customAuthType: "1",
      positionId: positionId,
      grant_type: 'custom',
      client_id: 'apiclient',
      client_secret: 'apisecret',
      token: localStorage.getItem('accessToken'),
    });
  }

  // 根据当前token重新获取token，如用户修改了语言配置信息
  export function reloadToken() {
    return fetch({
      customAuthType: "0",
      grant_type: 'custom',
      client_id: 'apiclient',
      client_secret: 'apisecret',
      token: localStorage.getItem('accessToken'),
    });
  }

  export async function loginOut() {
    nonBuRequest('/basicapi/oauth/logout', formatter({method: "POST"})).then((res) => {
      if (res.code == 200) {
        clearToken();
      }
    });
  }

  export function getSAMLToken(ticket: string, redirect: string | null) {
    return fetch({
      customAuthType: "2",
      grant_type: 'custom',
      client_id: 'apiclient',
      client_secret: 'apisecret',
      ticket: ticket,
      redirect: redirect,
      token: localStorage.getItem('accessToken'),
    });
  }

  export function getSsoUrl() {
    return defaultRequest('/basicapi/oauth/getSsoUrl', formatter({method: "GET"})).then((res) => {
      return {
        status: ResponseStatus.SUCCESS,
        data: res.data, // 假设后端返回的数据是单点登录 URL
      };
    });
  }

  export function ldapLogin(values: API.LoginParams) {
    return defaultRequest('/basicapi/oauth/ldapLogin',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(values)
      }).then((res) => {
      return {
        status: ResponseStatus.SUCCESS,
        data: res.data, // 假设后端返回的数据是单点登录 URL
      };
    });
  }

  //Sso登录
  export async function samlLogin(ticket: string, redirect: string | null) {
    //const ldapRes = await ldapLogin(values);
    // if (ldapRes.status !== ResponseStatus.SUCCESS || ldapRes.data == null) {
    //   message.error("ldap认证失败!");
    //   return;
    // }
    const tokenResult: API.TokenResult = await getSAMLToken(ticket, redirect);

    let loginResult: API.LoginResult;
    if (tokenResult.status === ResponseStatus.SUCCESS) {
      const res = await getUserinfo();
      loginResult = {
        status: ResponseStatus.SUCCESS,
        data: res.data,
      };
    } else {
      loginResult = {
        status: ResponseStatus.UNKNOWN,
        message: tokenResult.message
        //   message: '登陆账号[**]在本系统用户中不存在,用户认证失败',
      };
    }
    return loginResult;
  }


  export function setBuName(buName: String) {
    // @ts-ignore
    window["__TPM_BU_NAME__"] = buName
  }

  export function getBuName() {
    // @ts-ignore
    return window["__TPM_BU_NAME__"];
  }

  export function setBu(buId: any) {
    // @ts-ignore
    window["__TPM_BU_ID__"] = buId;
  }

  export function getBu() {
    // @ts-ignore
    return window["__TPM_BU_ID__"];
  }

  export function clearBu() {
    // @ts-ignore
    window["__TPM_BU_NAME__"] = null;
    // @ts-ignore
    window["__TPM_BU_ID__"] = null;
  }
}
